export const RESPONSE_TYPE = {
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
    INFO: "info",
    DEFAULT : "default",
    QUESTION : "question",
  };